import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import MinusCircleFilledSvg from "@ant-design/icons-svg/es/asn/MinusCircleFilled";
import AntdIcon from "../components/AntdIcon";
var MinusCircleFilled = function MinusCircleFilled(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: MinusCircleFilledSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  MinusCircleFilled.displayName = 'MinusCircleFilled';
}
export default /*#__PURE__*/React.forwardRef(MinusCircleFilled);